module.exports = __webpack_public_path__ + "img/gan-pro.da444d0e.jpg";